import { $taskKanbanBoard } from './states';
import { fetchTaskKanbanBoard } from './effects';

// Fetch kanban board
$taskKanbanBoard.on(fetchTaskKanbanBoard.doneData, (_, data) => data);
